import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import { StyleSheet } from "react-native";

export const CELL_SIZE = normalize(40);
export const CELL_BORDER_RADIUS = normalize(4);
export const MARGIN_HORIZONTAL = theme.spacing.xxs;

const styles = StyleSheet.create({
  codeFiledRoot: {
    display: "flex",
    marginBottom: normalize(20),
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  cell: {
    overflow: "hidden",
    marginRight: MARGIN_HORIZONTAL,
    height: CELL_SIZE * 1.4, // multiply by lineHeight
    width: CELL_SIZE - MARGIN_HORIZONTAL,
    borderRadius: CELL_BORDER_RADIUS,
    borderColor: theme.colors["neutral.white"],
    borderWidth: 1.5,
    justifyContent: "center",
  },
  separator: {
    height: normalize(2),
    width: CELL_SIZE * 0.2,
    borderRadius: 8,
    alignSelf: "center",
    backgroundColor: theme.colors["neutral.600"],
  },
  separatorBox: {
    width: CELL_SIZE * 0.2,
    marginRight: MARGIN_HORIZONTAL,
    height: CELL_SIZE * 1.4,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default styles;
